export enum LoadToTrailerModal {
  INVALID_BOL_ID = "INVALID_BOL_ID",
  GAYLORD_NOT_FOUND = "GAYLORD_NOT_FOUND",
  GAYLORD_STATUS_NOT_ALLOWED_FOR_TRAILER_SCAN = "GAYLORD_STATUS_NOT_ALLOWED_FOR_TRAILER_SCAN",
  ZONE_SKIP_GAYLORD_TRAILER_SCAN_AT_DESTINATION = "ZONE_SKIP_GAYLORD_TRAILER_SCAN_AT_DESTINATION",
  GAYLORD_TRANSFER_NOT_COMPLETE = "GAYLORD_TRANSFER_NOT_COMPLETE",
  TRAILER_ID_INPUT_MATCHES_GAYLORD_ID_FORMAT = "TRAILER_ID_INPUT_MATCHES_GAYLORD_ID_FORMAT",
  TRAILER_ID_INPUT_MATCHES_BOL_ID_FORMAT = "TRAILER_ID_INPUT_MATCHES_BOL_ID_FORMAT",
  INVALID_GAYLORD_ID = "INVALID_GAYLORD_ID",
  INVALID_BOL = "INVALID_BOL",
  MIDDLE_MILE_PARTNER_SELECTION = "MIDDLE_MILE_PARTNER_SELECTION",
  MISSING_MAIL_ID_FOR_AIR_SHIPMENT = "MISSING_MAIL_ID_FOR_AIR_SHIPMENT",
  QUINCE_NON_QUINCE_BOL_MISMATCH = "QUINCE_NON_QUINCE_BOL_MISMATCH",
  QUINCE_GAYLORD_TYPE_BOL_MISMATCH = "QUINCE_GAYLORD_TYPE_BOL_MISMATCH",
  INVALID_QUINCE_AIR_TRIP_ID_FORMAT = "INVALID_QUINCE_AIR_TRIP_ID_FORMAT",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
